import { Transport } from "../data/api/types/schedule";
import { ReportPrinter } from "./ReportPrinter";
import { PageData } from "./usePrintJourneyListData";

export function getVehicleText(
  page: PageData,
  selectedTransport: Transport,
  variant: 1 | 2 | 3 = 1
): string {
  let result;

  if (page.vehicle) {
    result = page.vehicle.vehicle_type_prefix;
  } else if (selectedTransport === "TM") {
    result = "ТМ";
  } else if (selectedTransport === "TB") {
    result = "ТБ";
  } else {
    result = "Автомобил";
  }

  if (result === "Автомобил") {
    switch (variant) {
      case 1:
        result = "Автомобил";
        break;
      case 2:
        result = "Автомобилът";
        break;
      case 3:
        result = "автомобила";
        break;
    }
  }

  return result;
}

export function printVehicle(
  printer: ReportPrinter,
  page: PageData,
  selectedTransport: Transport
) {
  const title = `${getVehicleText(page, selectedTransport)} марка:`;

  const { w: twidth1, h: theight1 } = printer.getDimensions(title);
  const { w: twidth2, h: theight2 } = printer.getDimensions("Придружители:");

  const twidth = Math.max(twidth1, twidth2);
  const theight = Math.max(theight1, theight2);

  printer.printText(title, printer.pageMarginX * 2);

  if (page.vehicle) {
    const mtsize = printer.withFont(
      () => {
        printer.doc.text(
          page.vehicle?.type || "",
          printer.pageMarginX * 2 + twidth + 10,
          printer.currentPageY - 1.6 * theight - 2
        );
        const size = printer.getWidth(page.vehicle?.type || "");

        if (page.vehicle?.dk_no) {
          printer.doc.text(
            page.vehicle.dk_no,
            printer.printableWidth,
            printer.currentPageY - 1.6 * theight - 2,
            { align: "right" }
          );
        }

        return size;
      },
      "slab-normal",
      12,
      1
    );

    if (page.vehicle && page.vehicle2_id) {
      printer.withFont(
        () => {
          printer.doc.text(
            `${page.vehicle?.vehicle_id.toString() || ""}  /  ${page.vehicle2_id || ""
            }`,
            printer.pageMarginX * 2 + twidth + Math.max(320, mtsize + 200),
            printer.currentPageY - 1.6 * theight - 2
          );
        },
        "slab-bold",
        18,
        1
      );
    } else {
      printer.withFont(
        () => {
          printer.doc.text(
            page.vehicle?.vehicle_id.toString() || "",
            printer.pageMarginX * 2 + twidth + Math.max(320, mtsize + 200),
            printer.currentPageY - 1.6 * theight - 2
          );
        },
        "slab-bold",
        18,
        1
      );
    }
  }

  return twidth;
}
